module.exports = __webpack_public_path__ + "static/media/default.bea50ba3.svg";